import { Page404, Qpay } from "pages";
import Layout from "layout";
import ApplicationPage from "pages/Application";
import CountdownPage from "pages/Countdown";
import ElementaryPage from "pages/Elementary";

const routes = [
  {
    path: "/",
    errorElement: <div>error</div>,
    element: <Layout />,
    children: [
      // {
      //   index: true,
      //   element: <CountdownPage />,
      // },
      {
        name: "Application",
        path: "/application",

        element: <ApplicationPage />,
      },
      {
        name: "Elementary",
        path: "/elementary",
        element: <ElementaryPage />,
      },
      {
        name: "Qpay",
        path: "/qpay/:guid",
        element: <Qpay />,
      },
      {
        name: "Not Found",
        path: "/*",
        element: <Page404 />,
      },
    ],
  },

  {
    name: "Not Found",
    path: "/*",
    element: <Page404 />,
  },
];

export default routes;
